import { useState, useEffect } from 'react';
import { BXPMediaResourceGroupsTable } from 'components/tables/BXPMediaResourceGroupsTable';
import {
  fetchBXPMediaResourceGroups,
  BXPMediaResourceGroup
} from 'services/hvaservicecampaign.service';

const BXPMediaResourceGroupList: React.FC = () => {
  // eslint-disable-next-line
  const [mediaResourceGroups, setMediaResourceGroups] = useState<BXPMediaResourceGroup[]>([]);
  const loadMediaResourceGroups = async (): Promise<void> => {
    try {
      const fetchedMediaResourceGroups = await fetchBXPMediaResourceGroups();
      setMediaResourceGroups(fetchedMediaResourceGroups);
    } catch (error) {
      console.error('Error loading media resource groups:', error);
    }
  };

  useEffect(() => {
    loadMediaResourceGroups();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPMediaResourceGroupsTable
          mediaResourceGroups={mediaResourceGroups}
          onMediaResourceGroupsChange={loadMediaResourceGroups}
        />
      </div>
    </div>
  );
};

export default BXPMediaResourceGroupList;
